// Mapeo confirmado contra BD real (SELECT * FROM catalogos WHERE tipo='plataforma'):
// valores exactos "Amazon Vendor"/"Amazon Seller"/"Shopify"/"Walmart"/"MercadoLibre"/
// "TikTok Shop" — TikTok Shop sigue sin PNG en /assets, cae al fallback de círculo.
const LOGO_POR_PLATAFORMA: Record<string, string> = {
  'Amazon Vendor': '/logos/vendor.png',
  'Amazon Seller': '/logos/seller.png',
  Shopify:         '/logos/shopify.png',
  Walmart:         '/logos/walmart.png',
  MercadoLibre:    '/logos/mercadolibre.png',
};

// Colores de badge por plataforma sin logo — igual que leadsphere-v2.html (platIcon()).
export function plataformaBadge(nombre: string): { letras: string; className: string } {
  const n = nombre.toLowerCase();
  if (n.startsWith('amazon')) return { letras: 'A', className: 'plat-amazon' };
  if (n === 'mercadolibre') return { letras: 'ML', className: 'plat-meli' };
  if (n === 'walmart') return { letras: 'W', className: 'plat-walmart' };
  return { letras: nombre.slice(0, 2).toUpperCase(), className: 'plat-otro' };
}

interface PlataformaLogoProps {
  nombre: string;
}

// Logo real (PNG) cuando existe mapeo; si no, cae al mismo badge de círculo con
// iniciales que ya se usaba para todas las plataformas — nunca rompe la UI.
export function PlataformaLogo({ nombre }: PlataformaLogoProps) {
  const logo = LOGO_POR_PLATAFORMA[nombre];
  if (logo) {
    return <img src={logo} alt={nombre} title={nombre} className="plat-logo" />;
  }

  const { letras, className } = plataformaBadge(nombre);
  return (
    <span className={`plat-icon ${className}`} title={nombre}>
      {letras}
    </span>
  );
}
